import { PrimaryButton } from "@digipost/dds-buttons-react";
import { Heading } from "@digipost/dds-heading-react";
import { FC, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router";

import InfoWarningText from "../InfoWarningText";
import { Dispatch } from "../infrastructure/redux/actions";
import { toIDPortenAction } from "../infrastructure/redux/app/app-actions";
import Translated from "../infrastructure/Translated";
import { useRootPath } from "../infrastructure/useRootPath";
import { useTranslate } from "../infrastructure/useTranslate";

export const Person: FC = () => {
  const location = useLocation();
  const dispatch = useDispatch<Dispatch>();
  const translate = useTranslate();
  const rootPath = useRootPath();
  const loginfeil = location.search.indexOf("loginfeil") > -1;

  useEffect(() => {
    document.title = `Digipost - ${translate("register.person.intro.title")}`;
    const description = document.querySelector("meta[name='description']");

    if (description) {
      description.setAttribute(
        "content",
        `${translate("register.person.intro.description")}`,
      );
    }
  }, [translate]);

  return (
    <>
      <div>
        <div className="register-content-wrapper">
          <div className="register-content-centered">
            <Heading level={1} size="large">
              <Translated textKey="register.person.intro.header" />
            </Heading>
          </div>
          {loginfeil && <InfoWarningText textkey="generic.error" />}
          <div className="register-info-wrapper">
            <Heading level={2} size="medium">
              <Translated textKey="register.person.intro.title" />
            </Heading>
            <div>
              <Translated
                textKey="register.person.intro.info"
                allowHtml={true}
              />
            </div>
          </div>
          <div className="register-accept-terms-wrapper">
            <div className="action">
              <PrimaryButton
                onClick={() => dispatch(toIDPortenAction(rootPath))}
                data-testid="person-button-to-idporten"
              >
                <Translated textKey="generic.continue" />
              </PrimaryButton>
            </div>
          </div>
        </div>
      </div>
      <div className="info-block">
        <div className="info-list">
          <div className="info-piece">
            <span className={`img img-idportenstøtte`} />
            <span className="info-title-1">
              <strong className="dds-bold">
                <Translated textKey="register.person.intro.bottom_info_1_title" />
              </strong>
            </span>
            <Translated
              textKey="register.person.intro.bottom_info_1"
              allowHtml={true}
            />
          </div>
          <div className="info-piece">
            <span className={`img img-kundestøtte`} />
            <span className="info-title-2">
              <strong className="dds-bold">
                <Translated textKey="register.person.intro.bottom_info_2_title" />
              </strong>
            </span>
            <Translated
              textKey="register.person.intro.bottom_info_2"
              allowHtml={true}
            />
          </div>
        </div>
      </div>
    </>
  );
};
